// TODO: remove this component
import styled from '@emotion/styled';
import { GroupElementScroll } from '@ferreri/prever-component-lib';

export const StyledGroupElementScroll = styled(GroupElementScroll)`
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;
